module.exports = __webpack_public_path__ + "static/radio-zuerisee-3790176e27c2f9e0404268ac74c249f8.png";